import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export const store = new Vuex.Store({    
    state: {
        menu_p_no: 0,
        menu_no: 0,
        menu_list: [],
        session: null,
        search: {},
        callInfo: null
    },
    plugins: [createPersistedState({ storage: window.sessionStorage })],
    mutations: {
        setSession: (state, session) => {
            state.session = session;
        },
        setMenuList: (state, menu_list) => {
            state.menu_list = menu_list;
        },
        setMenuNo: (state, menu) => {
            state.menu_p_no = menu.p_no;
            state.menu_no = menu.category_no;
        },
        setSearch: (state, search) => {
            state.search = search;
        },
        setCallInfo: (state, callInfo) => {
            state.callInfo = callInfo;
        }
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js